export enum StyleStatus {
    Generated = 'Generated',
    Submitted = 'Submitted',
    Revised = 'Revised',
    Integrated = 'Integrated'
}
